<template>
  <BaseDialog title="汇总单" @handleShow="(val) => { stockHZDialog = val }" :isshow="stockHZDialog"
    width="1000px" height="auto">
  <div>
    <div>
      <!-- 右侧按钮 -->
      <el-descriptions title="" :column="4" size="small" border style="margin-top: 16px">
        <el-descriptions-item label="查询机构" label-class-name="my-label"
          content-class-name="my-content">{{summary.fixmedins_name}}</el-descriptions-item>
        <el-descriptions-item label="查询科室" label-class-name="my-label"
          content-class-name="my-content">{{summary.department}}</el-descriptions-item>
        <el-descriptions-item label="时间" label-class-name="my-label"
          content-class-name="my-content">{{summary.time}}</el-descriptions-item>
        <el-descriptions-item label="操作人" label-class-name="my-label"
          content-class-name="my-content">{{summary.operator}}</el-descriptions-item>
        <el-descriptions-item label="采购价总额" label-class-name="my-label"
          content-class-name="my-content">{{summary.buy_price}}</el-descriptions-item>
        <el-descriptions-item label="出库价总额" label-class-name="my-label"
          content-class-name="my-content">{{summary.sell_price}}</el-descriptions-item>
      </el-descriptions>
      <!-- 表格内容 -->
      <div>
        <el-table v-loading="loading" ref="multipleTableRef" :data="tableData" size="small" style="width: 100%" stripe
          border max-height="50vh">
          <!-- <el-table-column type="selection" width="55" /> -->
          <el-table-column width="150" prop="order_no" label="单据号" fixed/>
          <el-table-column width="150" prop="out_time" label="操作日期" fixed/>
          <el-table-column width="150" prop="drug_code" label="医保编码" />
          <el-table-column width="180" prop="name" label="商品名"  show-overflow-tooltip>
          </el-table-column>
          <el-table-column width="150" property="medi_spec" label="规格" show-overflow-tooltip />
          <el-table-column width="180" property="company" label="厂家" show-overflow-tooltip />
          <el-table-column width="180" property="out_obj" label="目标单位" show-overflow-tooltip />
          <el-table-column width="120" prop="batch_no" label="批号" show-overflow-tooltip />
          <el-table-column width="100" prop="out_num_str" label="数量">
            <template #default="scope">
              <span>
                {{ scope.row.out_num_str }}
              </span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="单位" width="80" align="center">
            <template #default="scope">
              <span>{{ scope.row.unit }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="采购价" width="100" align="center">
            <template #default="scope">
              <span>{{ scope.row.buy_price}}元</span>
            </template>
          </el-table-column>
          <el-table-column label="采购金额" width="100" align="center">
            <template #default="scope">
              <span>{{ scope.row.total_buy_price}}元</span>
            </template>
          </el-table-column>
          <el-table-column label="零售价(出库价)" width="100" align="center">
            <template #default="scope">
              <span>{{ scope.row.sell_price}}元</span>
            </template>
          </el-table-column>

          <el-table-column label="零售金额(出库价总额)" width="100" align="center">
            <template #default="scope">
              <span>{{ scope.row.total_sell_price}}元</span>
            </template>
          </el-table-column>
          <el-table-column prop="validity_end_time" label="有效期" width="200" align="center" />
        </el-table>
      </div>
    </div>
  </div>
  </BaseDialog>
</template>

<script>
  import { Search, ArrowRightBold, ArrowLeftBold } from '@element-plus/icons-vue'
  import { toRefs, reactive, onMounted, nextTick, getCurrentInstance } from 'vue'
  import service from '@/utils/request'
  import BaseDialog from '@/components/Dialog/index.vue'
  import { gitDictList, TimeYear, downLoadXlsx, TimestampToTime } from '@/utils/tool'
  import { ElMessage, ElMessageBox } from 'element-plus'
  export default {
    components: {
      ArrowRightBold,
      BaseDialog,
    },
    props: {
      dictCatalogType: {
        type: String,
        default: '',
      },
      formInline: {
        type: Object,
        default: {},
      },
    },
    setup(props1) {
      let { proxy } = getCurrentInstance()
      const state = reactive({
        loading: false,
        tableData: [],
        dictCatalogType: '',
        stockHZDialog:false,
        summary:''
      })
      onMounted(() => {
        state.dictCatalogType = props1.dictCatalogType
      })
      // 获取列表
      const tobody = async () => {
        state.loading = true
        state.stockHZDialog = true
        let data = {}
        if (props1.formInline.time) {
          data = {
            start_time: props1.formInline.time[0],
            end_time: props1.formInline.time[1],
            drug_name: props1.formInline.drug_name,
            dict_catalog_type: props1.dictCatalogType,
            batch_no: props1.formInline.batch_no
          }
        } else {
          data = {
            drug_name: props1.formInline.drug_name,
            dict_catalog_type: props1.dictCatalogType,
            batch_no: props1.formInline.batch_no
          }
        }
        let res = await service.post('/api/store_out_record/getOutRecordExportList', data)
        if (res.code === 0) {
          if (res.data.total > 0) {
            state.tableData = res.data.records
            state.tableData.map(item=>{
              item.buy_price = Number(item.buy_price).toFixed(2)
              item.total_buy_price = Number(item.total_buy_price).toFixed(2)
              item.sell_price = Number(item.sell_price).toFixed(2)
              item.total_sell_price = Number(item.total_sell_price).toFixed(2)
            })
            state.summary = res.data.summary
            state.summary.buy_price = Number(state.summary.buy_price).toFixed(2)
            state.summary.sell_price = Number(state.summary.sell_price).toFixed(2)
          } else {
            state.tableData = []
          }
        }
        state.loading = false
      }
      return {
        ...toRefs(state),
        tobody
      }
    },
  }
</script>

<style scoped lang="scss">
  .demo-form-inline {
    display: flex;
    flex-wrap: wrap;
  }

  .adviceBox {
    height: 100%;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    padding: 10px;
  }

  .demo-tabs>.el-tabs__content {
    padding: 32px;
    color: #6b778c;
    font-size: 32px;
    font-weight: 600;
  }

  .display_flex {
    display: flex;
    justify-content: space-between;
  }

  .search-top .w-208 {
    width: 208px;

    .searchcss {
      cursor: pointer;
    }
  }

  .faicon {
    font-size: 19px;
    margin-right: 6px;
    cursor: pointer;
  }

  .title-top {
    align-items: center;
    display: flex;
  }

  .tabclis {
    height: 32px;
    background: rgba(49, 102, 174, 0.1);
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    display: flex;
    padding: 3px;

    .tabclis_right {
      display: flex;
      padding-top: 2px;
    }
  }

  .pagination-box {
    &:deep(.el-input__inner) {
      padding-right: 15px !important;
    }
  }

  .w-144 {
    margin-top: 20px;
  }

  .stop {
    background-color: #f4a939;
  }

  .modify {
    background-color: #3166ae;
  }

  .del {
    background-color: #ffecec;
    color: #ff6b6b;
    font-weight: 700;
  }

  .top {
    /* height: 35px; */
    margin: 8px 0;
  }

  .item {
    display: flex;
    flex-wrap: wrap;
  }
</style>

<style scoped>
  .saveRKSet {
    margin-top: 10px;
  }

  .el-input-group__append .el-select>>>.el-input__inner {
    border: none !important;
  }

  .el-form.w-144 .el-select {
    width: 100px !important;
  }

  .tables-left {
    margin-right: 10px;
    width: 30%;
  }

  .tables-right {
    margin-right: 10px;
    width: 70%;
  }

  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }

  .margin-set {
    padding: 10px;
    float: right;
  }

  .form-two {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }

  .form-two .el-form-item {
    width: 48% !important;
  }

  .iconcliss {
    width: 32px;
    height: 32px;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    color: #303030;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
    font-size: 18px;
  }
</style>